var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SelectPicker',_vm._b({attrs:{"label":"Region","name":"region","rules":"required","options":_vm.options},model:{value:(_vm.local_value),callback:function ($$v) {_vm.local_value=$$v},expression:"local_value"}},'SelectPicker',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }